<template>
    <div>
    <b-row role="alert">
        <b-col>
            <div class="sr-only" v-if="isLoading">Unassigned change requests loading, please wait...</div>
        </b-col>
    </b-row>
        <b-table hover small responsive show-empty
                 class="sr-caption"
                 aria-live="polite"
                 :id="slug"
                 :fields="fields"
                 :items="items"
                 primary-key="id"
                 :busy="isLoading"
                 :sort-by.sync="sortBy"
                 :sort-desc.sync="sortDesc"
                 caption="Unassigned Change Request table.  To sort the data in this table by a specific column,
                            go to the appropriate column header cell and use enter to sort the data ascending.
                            Use enter again to sort descending.">
            <template v-slot:cell(actions)="row">
                <b-button size="sm" @click="launchAssign(row.item)"
                          variant="primary"
                          class="mr-1">Assign</b-button>
            </template>
            <template v-slot:cell(submittedDate)="row">
                {{formatDateTime(row.item.changeDate)}}
            </template>
            <template v-slot:no-data>
                <b-button color="primary" @click="initialize">Reset</b-button>
            </template>
            <template v-slot:empty="scope">
                <p>No change requests found for this work queue.</p>
            </template>
            <div slot="table-busy" class="center-text text-danger my-2">
                <b-spinner class="align-middle" style="margin-right:5px; margin-top:12px;"
                           label="Loading, Please Wait" aria-label="Loading, Please Wait"></b-spinner>
                <strong>Loading, Please Wait...</strong>
            </div>
        </b-table>

    </div>
</template>
<script>
    import moment from 'moment';

    export default {
        name: "UnassignedTableList",

        props:{
            items: Array,
            slug: [String],
            isLoading: Boolean,
        },
        data:() => ({
            sortBy: 'submittedDate',
            sortDesc: true,
            fields:[
                {key: 'fullName', sortable: true, label: 'Name'},
                {key: 'ssn', sortable: true, label: 'SSN'},
                {key: 'submittedDate', sortable: true, label: 'Change Date'},
                {key: 'status', sortable: true, label: 'Status'},
                {key: 'type.description', label:'Request Type', sortable:true},
                {key: 'actions', label: 'Actions'}
            ]
        }),
        methods:{
            launchAssign(item){
                this.$router.push({path: `/credentialer-assign/${item.id}/${item.type.code}`});
            },
            formatDateTime(unformattedDate){
                let formattedDate = moment(unformattedDate);
                if(!formattedDate.isValid()) return '';
                return formattedDate.format("MM/DD/YYYY hh:mmA")
            }
        }
    }
</script>

<style scoped>

</style>